import { render } from "./BlackRuleDialog.vue?vue&type=template&id=31f249dc&scoped=true"
import script from "./BlackRuleDialog.vue?vue&type=script&lang=js"
export * from "./BlackRuleDialog.vue?vue&type=script&lang=js"

import "./BlackRuleDialog.vue?vue&type=style&index=0&id=31f249dc&scoped=true&lang=css"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31f249dc"]])

export default __exports__